import { armorAPI, unauthApi } from '~/services/api';
import { type JSONRegisterUser } from '~/types/RegisterUser';

export const register = (payload: JSONRegisterUser) =>
  unauthApi.request({
    data: payload,
    headers: {},
    method: 'POST',
    url: 'register/',
  });

export const registerMarketingData = (payload: Omit<JSONRegisterUser, 'user'>) =>
  armorAPI.request({
    data: payload,
    method: 'POST',
    url: '/register/marketing',
  });
